import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import GenericBanner from "./GenericBanner";
import Loyalty from "../../../api/Loyalty";

const LoyaltyPromoBanner: React.FC = () => {
    const navigate = useNavigate();
    const [cookies] = useCookies(["uuid", "brand_id"]);
    const { uuid, brand_id } = cookies;

    const [show, setShow] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("loyalty_banner_dismissed") === "true") return;
        if (!uuid || !brand_id) return;

        Loyalty.getConfig(uuid, brand_id).then((cfg) => {
            if (cfg && !cfg.loyaltyReferral && !cfg.loyaltySubscription) {
                setShow(true);
            }
        }).catch(console.error);
    }, [uuid, brand_id]);

    if (!show) return null;

    return (
        <GenericBanner
            title="Grow Your Client Base"
            description="Enable the Loyalty Program to attract new clients through referrals and keep them coming back with subscriptions."
            primaryCTA={{
                label: "Set Up Loyalty",
                onClick: () => navigate("/menu/loyalty"),
            }}
            closable
            onClose={() => {
                setShow(false);
                localStorage.setItem("loyalty_banner_dismissed", "true");
            }}
            variant="white"
        />
    );
};

export default LoyaltyPromoBanner;
